/**
 * Danh sách 14 nền tảng quảng cáo của màn "Quảng cáo đa nền tảng" (BOSS 14/10/2026).
 * Tách ra spec để menu trái (menu con của "Quảng cáo đa nền tảng", BOSS 19/10/2026) dùng chung
 * mà không kéo theo màn Kết nối nền tảng.
 */
export type MaNenTangQc =
  | 'meta-fb'
  | 'meta-ig'
  | 'meta-threads'
  | 'gg-search'
  | 'gg-ai-search'
  | 'gg-youtube'
  | 'tiktok'
  | 'baidu'
  | 'douyin'
  | 'zalo'
  | 'shopee'
  | 'chatgpt'
  | 'gemini'
  | 'khac';

export interface NenTangQc {
  ma: MaNenTangQc;
  ten: string;
  /** Mã nền tảng ở "Kết nối nền tảng" (bảng platforms) — null: chưa có mục kết nối. */
  ketNoi: string | null;
}

/** Đúng thứ tự BOSS liệt kê 14/10/2026. */
export const NEN_TANG_QC: readonly NenTangQc[] = [
  { ma: 'meta-fb', ten: 'Meta Facebook Ads', ketNoi: 'meta' },
  { ma: 'meta-ig', ten: 'Meta Instagram Ads', ketNoi: 'meta' },
  { ma: 'meta-threads', ten: 'Meta Threads Ads', ketNoi: 'meta' },
  { ma: 'gg-search', ten: 'Google Search Ads', ketNoi: 'gads' },
  { ma: 'gg-ai-search', ten: 'Google AI Search Ads', ketNoi: 'gads' },
  { ma: 'gg-youtube', ten: 'Google YouTube Ads', ketNoi: 'gads' },
  { ma: 'tiktok', ten: 'TikTok Ads', ketNoi: 'tiktok' },
  { ma: 'baidu', ten: 'Baidu Ads', ketNoi: null },
  { ma: 'douyin', ten: 'Douyin Ads', ketNoi: null },
  { ma: 'zalo', ten: 'Zalo Ads', ketNoi: 'zalooa' },
  { ma: 'shopee', ten: 'Shopee Ads', ketNoi: 'shopee' },
  { ma: 'chatgpt', ten: 'ChatGPT AI Ads', ketNoi: null },
  { ma: 'gemini', ten: 'Gemini AI Ads', ketNoi: null },
  { ma: 'khac', ten: 'Quảng cáo app khác', ketNoi: null },
];

export function laMaNenTangQc(x: string | null): x is MaNenTangQc {
  return NEN_TANG_QC.some((n) => n.ma === x);
}
